module.exports = __webpack_public_path__ + "img/information-record.cd214e9.svg";